var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button"},on:{"click":_vm.press,"mouseout":_vm.mouseOut}},[(!_vm.first)?_vm._t("default"):[_vm._v(" "+_vm._s(_vm.$t('admin.confirm'))+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }